import { Subject } from "rxjs";

export abstract class LoadingAbstraction {
  isLoading$ = new Subject<boolean>();
  isRecognition$ = new Subject<boolean>();
  abstract show(): void;
  abstract hide(): void;
}
